const SharingPermissionEnum = {
  ALL: 1,
  READ: 2,
  EDIT: 3,

  cases() {
    return {
      [this.ALL]: 'ALL',
      [this.READ]: 'READ',
      [this.EDIT]: 'EDIT',
    };
  },

  ids() {
    return Object.keys(this.cases()).map(Number);
  },

  names() {
    return Object.values(this.cases());
  },

  fromId(id) {
    return this.cases()[id] || null;
  },

  toId(name) {
    const cases = this.cases();
    return Object.keys(cases).find((key) => cases[key] === name) || null;
  },

  isValidId(id) {
    return this.ids().includes(id);
  },

  allOptions(includeAllOption = false) {
    const options = Object.entries(this.cases()).map(([id, name]) => ({
      id: Number(id),
      name,
    }));
    if (!includeAllOption) {
      return options.filter(option => option.name !== 'ALL');
    }
    return options;
  },
};

export default SharingPermissionEnum;
